import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class NgbDateYYYYMMDDAdapter extends NgbDateAdapter<string> {
  fromModel(value: string): NgbDateStruct | null {
    if (!value) {
      return null;
    }

    const parts = value.split('-');
    let year = +parts[0];
    const month = +parts[1];
    const day = +parts[2];

    // Expand 2-digit years into 2000+
    if (year < 100) {
      year = 2000 + year;
    }

    return { year, month, day };
  }

  toModel(ngbDate: NgbDateStruct): string | null {
    if (!ngbDate) {
      return null;
    }

    // Always ensure 4-digit year and 2-digit month/day
    const year = ngbDate.year.toString().padStart(4, '0');
    const month = ngbDate.month.toString().padStart(2, '0');
    const day = ngbDate.day.toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
}
